import { Select, SelectProps } from "antd";

import { TipoContatoEnum } from 'core/features/auth/typings/user'
import SelectBaseAntd from "../SelectBaseAntd";

export interface SelectContatoProps<T = any> extends SelectProps<T> {
  value: any;
  isInvalid?: boolean;
  onChange: (v: any, e: any) => void;
}


const { Option } = Select;

function SelectContato({ onChange, isInvalid, value, ...rest }: SelectContatoProps) {
  return (


    <SelectBaseAntd
      isInvalid={isInvalid}
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Tipo"
      style={{ width: "100%" }}
      value={value}
      showSearch={false}
      allowClear={false}
      {...rest}
      onChange={(v, ev) => {
        onChange(v, ev);
      }}
    >
      <Option value={TipoContatoEnum.AplicativoMensagem}>Aplicativo Mensagem</Option>
      <Option value={TipoContatoEnum.Carta}>Carta</Option>
      <Option value={TipoContatoEnum.Email}>Email</Option>
      <Option value={TipoContatoEnum.Telefone}>Telefone</Option>
      <Option value={TipoContatoEnum.SMS}>SMS</Option>
      <Option value={TipoContatoEnum.Celular}>Celular</Option>
      <Option value={TipoContatoEnum.Outros}>Outros</Option>
    </SelectBaseAntd>



  );
}

export default SelectContato;
